import styled from "~/ui/styled"

/** 协议正文段落（块级，段间距） */
export const LegalParagraph = styled.p<{ $color: string }>`
  display: block;
  margin: 0 0 12px;
  padding: 0;
  color: ${({ $color }) => $color};
  font-size: 14px;
  line-height: 1.65;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: justify;
`

/** 章节标题 */
export const LegalSectionTitle = styled.p<{ $color?: string }>`
  display: block;
  margin: 20px 0 10px;
  padding: 0;
  color: ${({ $color, theme }) => $color || theme.colors.text};
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
`

/** 文档主标题 */
export const LegalDocTitle = styled.p<{ $color?: string }>`
  display: block;
  margin: 0 0 16px;
  padding: 0;
  color: ${({ $color, theme }) => $color || theme.colors.text};
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
`

/** 元信息行（日期、公司等） */
export const LegalMeta = styled.p<{ $color: string }>`
  display: block;
  margin: 0 0 8px;
  padding: 0;
  color: ${({ $color }) => $color};
  font-size: 13px;
  line-height: 1.5;
`
